import { render } from "./Field.vue?vue&type=template&id=8afe55b2&scoped=true"
import script from "./Field.vue?vue&type=script&lang=js"
export * from "./Field.vue?vue&type=script&lang=js"

import "./Field.vue?vue&type=style&index=0&id=8afe55b2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ccjoe\\Documents\\CC2\\CareControlJobs\\FrontEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8afe55b2"]])

export default __exports__